import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';
import {
  IDefectType,
  IDelayReason,
  IWorkType,
  IGroupType,
  ICriticalLevel,
  IDefectTypeCost,
  ICity,
  IServiceType,
  ICheckList,
  IRemoteAppealType,
} from './interfaces';

export const getDefectTypeList = () => {
  return instance()
    .post('/defectType/list')
    .then((response) => response.data);
};

export const getDefectTypePagedList = (data: IDynamicTableParams) => {
  return instance()
    .post('/defectType/pagedList/', data)
    .then((response) => response.data);
};

export const getDefectTypeAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/defectType/availableColumns', {})
    .then((response) => response.data);
};

export const getDefectTypeAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/defectType/availableGroupColumns')
    .then((response) => response.data);
};

export const loadDefectType = (defectTypeId: number) => {
  return instance()
    .post<IDefectType>('/defectType/load', { defectTypeId })
    .then((response) => response.data);
};

export const saveDefectType = (data: IDefectType) => {
  return instance()
    .post('/defectType/save', data)
    .then((response) => response.data);
};

export const updateDefectType = (data: IDefectType) => {
  return instance()
    .post('/defectType/update', data)
    .then((response) => response.data);
};

export const deleteDefectType = (defectTypeId: number) => {
  return instance()
    .post('/defectType/delete', { defectTypeId })
    .then((response) => response.data);
};

export const recoverDefectType = (defectTypeId: number) => {
  return instance()
    .post('/defectType/recover', { defectTypeId })
    .then((response) => response.data);
};

export const getDefectTypeCostList = () => {
  return instance()
    .post<IDefectTypeCost[]>('/defectType/listCost')
    .then((response) => response.data);
};

// dictionaries
export const getDelayReasons = () => {
  return instance()
    .post<IDelayReason[]>('/dictionary/delayReason', {})
    .then((response) => response.data);
};

export const getZones = (config?: AxiosRequestConfig) => {
  return instance()
    .get('/zone/listAllNotDeleted', config)
    .then((response) => response.data);
};

export const getSubZones = (config?: AxiosRequestConfig) => {
  return instance()
    .get('/element/listAllNotDeleted', config)
    .then((response) => response.data);
};

export const getConstructives = (config?: AxiosRequestConfig) => {
  return instance()
    .get('/problem/listAllNotDeleted', config)
    .then((response) => response.data);
};

export const getSubConstructives = (config?: AxiosRequestConfig) => {
  return instance()
    .get('/system/listAllNotDeleted', config)
    .then((response) => response.data);
};

export const getAssignees = () => {
  return instance()
    .post('/dictionary/adminPositions/listExecutors', {})
    .then((response) => response.data);
};

export const getWorkTypes = () => {
  return instance()
    .post<IWorkType[]>('/dictionary/workTypes/list', {})
    .then((response) => response.data);
};

export const getGroupTypes = () => {
  return instance()
    .post<IGroupType[]>('/dictionary/groupTypes', {})
    .then((response) => response.data);
};

export const getCities = () => {
  return instance()
    .post<ICity[]>('/city/list', {})
    .then((response) => response.data);
};

export const getChecklistLevel = () => {
  return instance()
    .post<ICriticalLevel[]>('/checklist/level', {})
    .then((response) => response.data);
};

export const getServiceTypes = () => {
  return instance()
    .get<IServiceType[]>('/serviceType/listAllNotDeleted')
    .then((response) => response.data);
};

export const getRemoteAppealTypes = () => {
  return instance()
    .post<IRemoteAppealType[]>('/dictionary/remoteAppealTypes', {})
    .then((response) => response.data);
};

export const getChecklistApplicationListAllNotDeleted = () => {
  return instance()
    .post<ICheckList[]>('/checkListApplication/listAllNotDeleted')
    .then((response) => response.data);
};
